export const limit = 7e+6; // 7мб
